export enum CodeSet {
  CCSD = 'CCSD',
  OPCS = 'OPCS',
}

export const CodeSets = Object.values(CodeSet);
